import { useDispatch } from "react-redux";
import classNames from "classnames";
import CloseButton from "../../core/CloseButton";
import { closeFlash } from "../../../actions/flashes-actions";

const Flash = ({ flash }) => {
  const dispatch = useDispatch();

  return (
    <div
      className={classNames(
        "font-size-sm",
        "alert",
        flash.variant && `alert-${flash.variant}`,
        flash.persist && "undismissible",
      )}
    >
      {!flash.persist && (
        <div className="p-3 m-1" />
      )}
      <p className="mb-0">
        {flash.message}
      </p>
      {!flash.persist && (
        <CloseButton
          className="alert-close"
          onClick={() => dispatch(closeFlash(flash.key))}
          variant={(flash.variant === "warning") ? "ghost-dark" : "ghost-white"}
        />
      )}
    </div>
  );
};

export default Flash;
